import React, { useState, useRef, useEffect, MouseEvent } from 'react';
import styled from 'styled-components';
import useStream from '../hooks/useStream';

const Video = styled.video`
  width:320px;
  height:240px;
  transform:rotateY(180deg);
  border-radius:2em;
  :hover {
    border: 3px solid #a00;
  }
  position:fixed;
  top: 0;
  left: 0;
  filter:brightness(90%);
  filter:contrast(105%);
  filter:blur(0px);
`;

const DraggableVideo = () => {
  const ref = useRef<HTMLVideoElement>(null);
  const [drag, setDrag] = useState<boolean>(false);
  const stream = useStream();

  useEffect(() => {
    if(!!ref.current)
      (ref.current as unknown as HTMLMediaElement).srcObject = stream;
  }, [stream]);

  return (
    <Video
      autoPlay
      playsinline
      // controls
      muted
      // controlsListyar
      ref={ref}
      onMouseUp={(e:MouseEvent<HTMLElement>)=>{
        setDrag(false);
      }}
      onMouseDown={(e:MouseEvent<HTMLElement>)=>{
        setDrag(true);
      }}
      onMouseMove={(e:MouseEvent<HTMLElement>)=>{
        if(ref.current && drag) {
          if(ref?.current)
            ref.current.style.top = `${e.pageY - 120}px`;
            ref.current.style.left= `${e.pageX - 160}px`;
        }
      }}
    />
  )
}

export default DraggableVideo;